const MINIMUM_SEARCH_LENGTH = 2;
const DEBOUNCE_DELAY = 300;
const LABELS = {
  origin: 'Origem da carga*',
  delivery: 'Destino da carga*',
} as const;
const MESSAGES = {
  placeholder: 'Informe a cidade',
  hint: 'Campo obrigatório.',
  emptyResults: 'Nenhum resultado encontrado. Tente outro endereço.',
} as const;

export { MINIMUM_SEARCH_LENGTH, DEBOUNCE_DELAY, LABELS, MESSAGES };
